import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "male",
  "use": "male-usage",
  "viewBox": "0 0 22 20",
  "content": "<symbol viewBox=\"0 0 22 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"male\"><path d=\"M21.019 20H.11c-.012-.21-.026-.422-.05-.67-.065-.831-.13-1.687.102-2.47.282-.917 1.014-1.724 2.709-2.22l.655-.211c2.979-.856 4.572-1.34 5.098-2.47l.168-.284-.013-.36a.47.47 0 0 1-.116-.112 6.27 6.27 0 0 1-.527-.594C6.982 9.13 6.16 6.849 6.16 4.964 6.16 2.556 7.933 0 10.577 0c2.068 0 4.29 2.06 4.29 5.137 0 1.96-1.014 4.391-2.401 5.819-.09.1-.193.185-.283.273l-.166.15.05.223c.36 1.414 1.978 1.898 5.227 2.828l.668.21c1.683.498 2.479 1.317 2.826 2.222h.012c.322.88.283 1.837.244 2.73-.013.135-.013.283-.025.408\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/male.svg
// module id = 1551
// module chunks = 0